import axios from "@/axios";

const getDefaultState = () => ({
    unidades: [],
	unidades_detalhes: []
});
  
const state = getDefaultState();

const mutations = {
	SET_UNIDADES(state, unidades) {
		state.unidades = unidades;
	},
	SET_UNIDADES_DETALHES(state, detalhes) {
        state.unidades_detalhes = detalhes;
    },
    reset(state) {
        Object.assign(state, getDefaultState());
    }
};

const actions = {
	async fetchUnidades({ commit }) {
		try {
			const response = await axios.get("/unidades");
			commit("SET_UNIDADES", response.data.unidades);
		} catch (error) {
			console.error("Erro ao buscar unidades:", error);
			throw error;
		}
	},

	async fetchUnidadesDetalhes({ commit }) {
        try {
            const response = await axios.get("/unidades/detalhes");
            
            const dadosUnidades = response.data.data || response.data.unidades;
            
            // Comita para a mutação correta sem mexer no state.unidades
            commit("SET_UNIDADES_DETALHES", dadosUnidades);

            return dadosUnidades;
        } catch (error) {
            console.error("Erro ao buscar detalhes das unidades:", error);
            throw error;
        }
    },

	async fetchLogsDataRelatorio(_, {unidadeId, dataInicio, dataFim, page, per_page}) {
        try {
            const response = await axios.get(`/unidades/${unidadeId}/logs/${dataInicio}/${dataFim}?page=${page}&per_page=${per_page}`);
            return response.data;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    },

	async fetchUnidadesConsultaAvancada(_, {ids, regras, data}) {
		try {
			const response = await axios.post("/unidades/consulta-avancada", {
				ids,
				regras,
				data
			});
			return response.data;
		} catch (error) {
			console.error("Erro ao buscar unidades consulta avançada:", error);
			throw error;
		}
	}
};

const getters = {
	getUnidades: (state) =>  state.unidades,
	getUnidadesDetalhes: (state) => state.unidades_detalhes
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
